
import { Component, Vue } from "vue-property-decorator";
import DimssaButton from "@/components/shared/dimssa-button.vue";

@Component({
  components: {
    DimssaButton,
  },
})
export default class Home extends Vue {
  get showFixDispatchBatches() {
    return (this.$store.state as any).user?.user?.email === "dolan@gigalot.co.za";
  }

  get showIntakeBatchChangeOwnerButton() {
    return this.$store.state.user.user?.email === "dolan@gigalot.co.za";
  }

  get showProcessingResultCorrectionsButton() {
    return this.$store.state.user.user?.email === "dolan@gigalot.co.za";
  }

  created() {
    this.$store.commit("navFuncs", { save: undefined, back: undefined });
  }
  async kraals() {
    throw Error("TODO: add idb object store for Kraal");
  }

  async feed() {}

  logout() {
    this.$store.commit("popup/displayYesNo", {
      messages: ["Are you sure you want to log out?"],
      yesAction: () => {
        this.$store.dispatch("user/signOut");
      },
    });
  }
}
